import API from "../base.service";
import { ENDPOINT } from "../../constants.service";

const shopProducts = async (id, data = {}) => {
  const url = `${ENDPOINT.outlet.outlet.products}`.replace(":id", id);
  return await API.getMethod(url, true, true, data);
};
const addShopProducts = async (id, data) => {
  const url = `${ENDPOINT.outlet.outlet.addProducts}`.replace(":id", id);
  return await API.postMethod(url, true, data, false);
};
const deleteShopProduct = async (outletId, productId) => {
  const url = `${ENDPOINT.outlet.outlet.deleteProduct}`
    .replace(":outletId", outletId)
    .replace(":productId", productId);
  return await API.deleteMethod(url, true);
};

const deleteMainStock = async (id) => {
  const url = `${ENDPOINT.inventory.outletStock.delete}`.replace(":id", id);
  return await API.deleteMethod(url, true);
};

const getMainStock = async (id) => {
  const url = `${ENDPOINT.inventory.outletStock.show}`.replace(":id", id);
  return await API.getMethod(url, true);
};
const updateStockPrice = async (id) => {
  const url = `${ENDPOINT.inventory.outletStock.export}`.replace(":id", id);
  return await API.postMethod(url, true);
};

export default {
  getMainStock,
  deleteMainStock,
  updateStockPrice,

  shopProducts,
  addShopProducts,
  deleteShopProduct,
};
